import { getLuminance, getContrast } from 'polished';

export const readableColor = (color, aboveColor = '', darkColor = '#000', lightColor = '#fff') => {
  try {
    const luminance = getLuminance(color);
    const contrast = aboveColor ? getContrast(color, aboveColor) : 0;
    const readable = luminance > 0.225 ? darkColor : lightColor;
    return contrast > 4 ? aboveColor : readable;
  } catch (e) {
    return darkColor;
  }
};

export const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    ? `
      ${parseInt(result[1], 16)},
      ${parseInt(result[2], 16)},
      ${parseInt(result[3], 16)}`
    : null;
};

export const webkitScrollBarWeight = {
  thin: '8px',
  auto: 'auto',
  none: '0',
};

export const hasTransparency = (val) => {
  if (val?.includes('rgba')) {
    return !!val.replace(/^.*,(.+)\)/, '$1');
  }
  return false;
};

export const contentAlignment = (val1, val2) => {
  if (val1 === 'start' && val2 === 'start') {
    return 'flex-start';
  }
  if (val1 === 'end' && val2 === 'end') {
    return 'flex-end';
  }
  if (val1 === 'center' && val2 === 'center') {
    return 'center';
  }
  if ((val1 === 'start' && val2 === 'end') || (val1 === 'end' && val2 === 'start')) {
    return 'space-between';
  }
  return 'center';
};

export const getDefaultTheme = (p1Theme) => (
  {
    multiDropdown: {
      titleColor: p1Theme.color.text,
      titleFontSize: '15px',
      titleFontType: 'font-primary',
      titleFontWeight: 'bold',
      textColor: p1Theme.color.text,
      fontSize: '15px',
      fontType: 'font-primary',
      fontWeight: 'normal',
      backgroundColor: p1Theme.color.background,
      padding: '15px',
      borderColor: p1Theme.color.background,
      borderSize: '0',
      dropShadow: true,
    },
    bubbles: {
      textColor: p1Theme.color.text,
      bubbleSize: '96px',
      hoverTextColor: readableColor(p1Theme.color.primary),
      backgroundColor: '',
      hoverBackgroundColor: p1Theme.color.primary,
      borderColor: p1Theme.color.text,
      hoverBorderColor: p1Theme.color.primary,
      borderSize: '1px',
      borderRadius: '25px',
    },
    inputFields: {
      textColor: '#000',
      backgroundColor: '#fff',
      borderColor: '#000',
      borderSize: '1px',
      borderRadius: '3px',
      placeholderText: '...Search',
    },
    scrollBars: {
      weight: 'thin',
      trackColor: '#ffffff',
      handleColor: p1Theme.color.primary,
      hoverHandleColor: '',
    },
    singleDropdown: {
      textColor: p1Theme.color.text,
      hoverTextColor: p1Theme.color.primary,
      backgroundColor: p1Theme.color.background,
      borderColor: p1Theme.color.text,
      borderSize: '1px 1px 1px 1px',
    },
    navBar: {
      textColor: p1Theme.color.text,
    },
    buttons: {
      apply: {
        label: 'Apply',
        fontType: 'font-primary',
        buttonSize: 'auto',
        buttonAligned: 'end',
        textAlign: 'center',
        backgroundColor: p1Theme.color.primary,
        hoverBackgroundColor: '',
        textColor: readableColor(p1Theme.color.primary),
        hoverTextColor: '',
        pcFontSize: '0.9em',
        mobileFontSize: '0.9em',
        fontWeight: 'normal',
        borderSize: '1px',
        borderRadius: '3px',
        borderColor: p1Theme.color.primary,
        hoverBorderColor: '',
        padding: '7px 16px 7px 16px',
        hasDarkerGradient: false,
        hasDropShadow: false,
        transitionTime: '',
      },
      reset: {
        label: 'Reset',
        fontType: 'font-primary',
        buttonSize: 'auto',
        buttonAligned: 'end',
        textAlign: 'center',
        backgroundColor: '',
        hoverBackgroundColor: '',
        textColor: p1Theme.color.text,
        hoverTextColor: '',
        pcFontSize: '0.9em',
        mobileFontSize: '0.9em',
        isBold: false,
        borderSize: '1px',
        borderRadius: '3px',
        borderColor: p1Theme.color.text,
        hoverBorderColor: '',
        padding: '7px 16px 7px 16px',
        isDarkerGradient: false,
        hasDropShadow: false,
        transitionTime: '',
      },
      topLevelBubbles: null,
    },
  }
);
